module.exports = __webpack_public_path__ + "static/img/icons-arrow-1-left.b1966bd8.svg";